import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import useStore from '../store/useStore';

const SUPERADMIN_NAV = [
  { to: '/superadmin', label: 'Dashboard', icon: '⊞', end: true },
  { to: '/superadmin/admins', label: 'Admin Lists', icon: '👥' },
  { to: '/superadmin/email', label: 'Email', icon: '✉️' },
  { to: '/superadmin/email/extractor', label: 'Email Extractor', icon: '🔍' },
  { to: '/superadmin/accounts', label: 'All Accounts', icon: '📬' },
  { to: '/superadmin/links', label: 'All Links', icon: '🔗', end: true },
  { to: '/superadmin/links/new', label: 'Generate Link', icon: '✨' },
  { to: '/superadmin/mylinks', label: 'SA Links', icon: '🗂️' },
  { to: '/superadmin/letters', label: 'Letter Builder', icon: '📨' },
  { to: '/superadmin/analytics', label: 'Analytics', icon: '📈' },
  { to: '/superadmin/templates', label: 'Templates', icon: '🎨' },
  { to: '/superadmin/activity', label: 'Activity', icon: '📋' },
  { to: '/superadmin/settings', label: 'Settings', icon: '⚙️' },
];

const ADMIN_NAV = [
  { to: '/dashboard', label: 'Dashboard', icon: '⊞', end: true },
  { to: '/email', label: 'Email', icon: '✉️' },
  { to: '/email/extractor', label: 'Email Extractor', icon: '🔍' },
  { to: '/dashboard/links/new', label: 'Generate Link', icon: '✨' },
  { to: '/dashboard/letters', label: 'Letter Builder', icon: '📨' },
  { to: '/dashboard/templates', label: 'Templates', icon: '🎨' },
  { to: '/dashboard/links', label: 'My Links', icon: '🔗', end: true },
  { to: '/dashboard/campaigns', label: 'Campaigns', icon: '📬' },
  { to: '/dashboard/stats', label: 'Statistics', icon: '📊' },
  { to: '/dashboard/settings', label: 'Settings', icon: '⚙️' },
  { to: '/dashboard/self-hosted', label: 'Self-Hosted', icon: '🌐' },
];

export default function Sidebar({ role }) {
  const { user, logout } = useStore();
  const nav = role === 'superadmin' ? SUPERADMIN_NAV : ADMIN_NAV;

  return (
    <aside className="sidebar">
      <div className="sidebar-logo">ClassMail Client</div>
      <nav className="sidebar-nav">
        {nav.map(item => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}
          >
            <span>{item.icon}</span>
            {item.label}
          </NavLink>
        ))}
      </nav>
      <div className="sidebar-footer">
        <div style={{ marginBottom: 6, color: 'var(--text2)' }}>{user?.username}</div>
        <button className="btn btn-ghost btn-sm" style={{ width: '100%' }} onClick={logout}>
          Sign out
        </button>
      </div>
    </aside>
  );
}
